"use strict";

import Global from "/js/core/global.js";

/**
 * Layout metrics logic.
 * (Not to be confused with analytics)
 *
 * TODO: Some or a lot of this can be simplified or removed bc designs have changed a number of times
 */
export default class Metrics {

  // TODO: Too many references to $("#lesson")...

  // All these values must be in sync with the variables in `base.scss`.
  static _MOBILE_MAX_WIDTH = 767;
  static _CARD_WIDTH = 344;
  static _CARD_HEIGHT = 464;

  static _INTERACTION_WIDTH = 344;
  static _INTERACTION_HEIGHT = 548;

  // TODO: Too much reliance on these css-derived values :(

  static _MOBILE_HEADER_HEIGHT = 55;
  static _MOBILE_CTA_HEIGHT = 55;
  static _MOBILE_CARDVIEW_WITH_CTA_MARGIN_TOP = 0;
  static _MOBILE_CARDVIEW_WITHOUT_CTA_MARGIN_TOP = 24;
  static _MOBILE_BUTTON_HEIGHT = 44;
  static _MOBILE_BUTTON_MARGIN_TOP = 24;
  static _MOBILE_CARDVIEW_MARGIN_BOTTOM = 24;
  static _MOBILE_CARD_MARGIN_H = 20;
  static _MOBILE_INTERACTION_MARGIN_BOTTOM = 24;


  static _$layoutType = null;

  static get cardWidth() { 
    return Metrics._CARD_WIDTH;
  }
  
  static get cardHeight() { 
    return Metrics._CARD_HEIGHT;
  }

  /** 
   * The width of the element "#layoutType" changes based on breakpoint, due to its css definition. 
   * We use this to determine programmatically if the mobile breakpoint is being applied.
   */
  static get isMobileWidth() {
    if (!Metrics._$layoutType) {
      Metrics._$layoutType = $('#layoutType');
    }
    const w = Math.round(Metrics._$layoutType.width());
    return w === 1;
  }

  static get mobileMaxWidth() {
    return this._MOBILE_MAX_WIDTH;
  }

  /**
   * Calculates the scale factor used for the cards (and which is also applied to the interaction 
   * view and complete view).
   */
  static calcCardScale() {
    
    const mainHeight = $("#lesson").height();
    const mainWidth = $("#lesson").width();

    let scale;

    if (Metrics.isMobileWidth) {

      // Calculate scale based on viewport width:

      const targetWidth = mainWidth - (Metrics._MOBILE_CARD_MARGIN_H * 2);
      const referenceWidth = Metrics.cardWidth;
      scale = targetWidth / referenceWidth;

      // If too short, must shrink further.
      const usableHeight = Metrics.#getMobileCardViewUsableHeight();
      const usedHeight = Metrics.#getMobileCardViewHeight(scale);
      if (usedHeight > usableHeight) {
        const ratio = usableHeight / usedHeight;
        scale *= ratio;
      }
    } else {

      // Calculate scale based on viewport height:

      const targetHeight = mainHeight * 0.666;
      const referenceHeight = Metrics.cardHeight;
      scale = targetHeight / referenceHeight;  

      // If viewport is too narrow, must shrink further.
      // Minimum required width is: card + margin + button + outer margin. 
      // TODO: Use constants or css values or smth
      const minWidth = (Metrics.cardWidth  +  20 * 2  +  42 * 2  +  20 * 2) * scale; 
      if (mainWidth < minWidth) {
        const ratio = mainWidth / minWidth;
        scale *= ratio;
      }
    }

    // Limit minimum scale (Will cause content to get cropped rather than shrinking awkwardly).
    if (scale < 0.5) {
      scale = 0.5;
    }

    return scale;
  }

  static calcCardViewY() {
    if (Metrics.isMobileWidth) {
      return Metrics.#getMobileCardViewY(Global.cardScale);
    } else {
      return $("#lesson").height() / 2;  // ez
    }
  }

  static calcDoneViewY() {
    if (!Metrics.isMobileWidth) {
      return "50%";  // matches the css
    } else {
      // Must be calculated programmatically:
      const range = this.getMobileDoneViewVerticalRange();
      return range[0] + (range[1] - range[0]) / 2;
    }
  }

  /**
   * Returns the height of mobile layout's card view lockup in pixels.
   */
  static #getMobileCardViewHeight(scale) {

    let ht = Metrics.cardHeight;
    ht += Metrics._MOBILE_BUTTON_MARGIN_TOP;
    ht += Metrics._MOBILE_BUTTON_HEIGHT;

    ht *= scale;

    return ht;
  }

  /**
   * Mumble mumble
   */
  static #getMobileCardViewY(scale) {
    let y = Metrics.getMobileHeaderAreaBottom();
    y += Global.hasCta
        ? Metrics._MOBILE_CARDVIEW_WITH_CTA_MARGIN_TOP
        : Metrics._MOBILE_CARDVIEW_WITHOUT_CTA_MARGIN_TOP;
    const usedHeight = Metrics.#getMobileCardViewHeight(scale);
    const usableHeight = Metrics.#getMobileCardViewUsableHeight();
    const fullHeight = $("#lesson").height();
    const offset = (usableHeight - usedHeight) / 2;
    y += offset;

    y += (Metrics.cardHeight * scale) / 2;
    return y;
  }

  /**
   * Returns the vertical range within which the interaction view should position itself.
   */
  static getMobileInteractionViewVerticalRange() {    
    let top = Metrics.getMobileHeaderAreaBottom();
    top += Global.hasCta
        ? Metrics._MOBILE_CARDVIEW_WITH_CTA_MARGIN_TOP
        : Metrics._MOBILE_CARDVIEW_WITHOUT_CTA_MARGIN_TOP;    
    const bottom = $("#lesson").height() - Metrics._MOBILE_INTERACTION_MARGIN_BOTTOM;
    return [top, bottom];
  }

  /**
   * Returns the vertical range within which the interaction view should position itself.
   */
  static getMobileDoneViewVerticalRange() {    
    let top = Metrics._MOBILE_HEADER_HEIGHT;
    top += Metrics._MOBILE_CARDVIEW_WITHOUT_CTA_MARGIN_TOP;    
    const bottom = $("#lesson").height() - Metrics._MOBILE_INTERACTION_MARGIN_BOTTOM;
    return [top, bottom];
  }

  /**
   * Returns the mobile "safe area" height.
   */
  static #getMobileCardViewUsableHeight() {
    let ht = $("#lesson").height();
    ht -= Metrics.getMobileHeaderAreaBottom();
    ht -= Global.hasCta 
        ? Metrics._MOBILE_CARDVIEW_WITH_CTA_MARGIN_TOP
        : Metrics._MOBILE_CARDVIEW_WITHOUT_CTA_MARGIN_TOP;
    ht -= Metrics._MOBILE_CARDVIEW_MARGIN_BOTTOM;
    return ht;
  }

  static getMobileHeaderAreaBottom() {  // rem, does not apply to doneview
    let y = Metrics._MOBILE_HEADER_HEIGHT;
    if (Global.hasCta) {
      y += Metrics._MOBILE_CTA_HEIGHT;
    }
    return y;
  }
}